import { render, staticRenderFns } from "./EquipmentDetail.vue?vue&type=template&id=8f78246a&scoped=true"
import script from "./EquipmentDetail.vue?vue&type=script&lang=js"
export * from "./EquipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./EquipmentDetail.vue?vue&type=style&index=0&id=8f78246a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f78246a",
  null
  
)

export default component.exports